import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo } from "react";
import { useCheckSapStatus } from "./useCheckSapStatus";
// TODO(sap-sync-flag): remove these checks when the SAP sync feature flag is removed
import { isSapInvoiceSyncEnabledForDoc, isSapProfileSyncEnabledForAnyDoc, isSapProfileSyncEnabledForDoc, } from "../feature_flag.generated";
import { useSiteStatus } from "@iscr/xAppLib/Hooks";
export const SapSyncContext = createContext(undefined);
export const useSapSyncContext = () => {
    const ctx = useContext(SapSyncContext);
    if (!ctx) {
        throw new Error("useSapSyncContext must be used within SapSyncProvider");
    }
    return ctx;
};
export const useSapStatus = () => useSapSyncContext().sapStatus;
/**
 * Checks SAP availability once for the whole dashboard, so the indicator keeps reporting across tab
 * switches and any tab content that cares (e.g. blocking invoice generation while SAP is down)
 * reads the same result instead of firing its own check.
 */
export const SapSyncProvider = ({ children }) => {
    const { status, recheck } = useCheckSapStatus();
    const sap_sync_enabled = useSiteStatus("sap_sync_enabled");
    const value = useMemo(() => ({
        sapStatus: status,
        recheck,
        enabled: isSapProfileSyncEnabledForAnyDoc(sap_sync_enabled),
        sap_sync_enabled,
        isProfileSyncEnabledForDoc: (doc_id) => isSapProfileSyncEnabledForDoc(sap_sync_enabled, doc_id),
        isInvoiceSyncEnabledForDoc: (doc_id) => isSapInvoiceSyncEnabledForDoc(sap_sync_enabled, doc_id),
    }), [status, recheck, sap_sync_enabled]);
    return _jsx(SapSyncContext.Provider, { value: value, children: children });
};
